import React, { Component, Fragment } from 'react';
import { Provider } from 'react-redux';
import EnquireModal from '../../components/EnquireModal';
import EventListener from '../../components/EventListener';

export default class App extends Component {
  render() {
    const { store } = this.props;
    return (
      <Provider store={store}>
        <Fragment>
          <EnquireModal />
          <EventListener />
        </Fragment>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/containers/App/App.js